import { KatIcon } from "@amzn/katal-react";
import React from "react";
import { useTranslation } from "react-i18next";
import Markdown from "markdown-to-jsx";
import { useCountrySelection } from "src/components/Contexts/CountrySelectionContext";
import { NestPanel } from "../NestPanel";

export function NestDisclaimerPanel() {
  const { t } = useTranslation();
  const { selectedCountry } = useCountrySelection();
  const suffix = selectedCountry?.countryCode?.toLowerCase() ?? "";

  return (
    <NestPanel
      title={t("aic_nest_disclaimer_title")}
      icon={<KatIcon name="info" size="small" />}
      footer={<Markdown>{t(`aic_nest_disclaimer_footer_${suffix}`)}</Markdown>}
    >
      <Markdown>{t(`aic_nest_disclaimer_body_${suffix}`)}</Markdown>
    </NestPanel>
  );
}
